// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./less/sbadmin2/sb-admin-2.less
// module id = 1187
// module chunks = 0